<template>
    <div :class="{isActive:active}" class="selectitem mb-3" @click="checkout">
        <div class="checkbox">
            <i v-if="!active" class="far fa-square"></i> <i v-else class="far fa-check-square"></i>
        </div>
        <div class="text">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "select-item",

        props: {
            value: {
                type: String,
                required: true
            },
            active: false
        },

        methods: {
            checkout () {
                this.$emit('select', this.value)
            }
        }
    }
</script>

<style scoped>

    .selectitem {
        border: 1px solid rgba(0,0,0,.125);
            /*border-radius: .2rem;*/
        overflow: hidden;
    }

    .selectitem:hover {
        background: #F1F1F1;
        cursor: pointer;
    }

    .selectitem > .checkbox {
        color: #ccc;
        width: 10%;
        text-align: center;
        background: #f1f1f1;
        border-right: 1px solid #ccc;
        font-size: 1.1em;
        margin-right: 10px;
    }

    .selectitem > .text,
    .selectitem > .checkbox {
        transition: all .3s;
        display: inline-block;
        padding: 5px;
    }


    .isActive .checkbox,
    .selectitem:hover .checkbox{
        background: #007bff;
        color: white;
    }

    .isActive.selectitem {
        background: #F1F1F1;
    }

</style>